module.exports = __webpack_public_path__ + "media/images/coin-796695f2986af3ad587dad47e7bed636.png";